
import React from 'react';
import { VALUES, getIcon } from '../constants';

const Values: React.FC = () => {
  return (
    <section id="values" className="py-24 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-sm font-bold text-avus-blue uppercase tracking-widest mb-4">Our Principles</h2>
          <h3 className="text-4xl font-bold text-avus-navy">The Values That Drive Us</h3>
        </div>

        <div className="relative">
          {/* Horizontal line for desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-[1px] bg-slate-200 -translate-y-1/2 z-0"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10">
            {VALUES.map((value, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                <div className="relative mb-8 group">
                  {/* Decorative dashed circle */}
                  <div className="absolute inset-0 rounded-full border-2 border-dashed border-avus-light animate-[spin_20s_linear_infinite] p-2"></div>
                  
                  <div className="relative w-32 h-32 bg-white rounded-full flex items-center justify-center shadow-lg border border-slate-100 z-10 group-hover:scale-110 transition-transform duration-300">
                    <div className="text-avus-blue">
                      {getIcon(value.icon, 40)}
                    </div>
                  </div>
                </div>
                <h4 className="text-xl font-bold text-avus-navy mb-4">{value.title}</h4>
                <p className="text-slate-600 max-w-xs mx-auto leading-relaxed font-medium">
                  {value.longDescription}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Values;
